import { ListItemText } from '../../../../ExternalLibraries';

export default ListItemText;
